import { render, staticRenderFns } from "./confirmAdd.vue?vue&type=template&id=c051d79e&scoped=true&"
import script from "./confirmAdd.vue?vue&type=script&lang=js&"
export * from "./confirmAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c051d79e",
  null
  
)

export default component.exports